export default __webpack_public_path__ + "static/media/ic_three_dots.c77665ff.svg";